import Image from 'next/image';
import { UserPlus, BookAlt } from '@styled-icons/boxicons-regular';

import { Colors, FeatureGrid, Text, staticCdnHost } from '@rockalingua/ui';
import { Container } from './HowItWorks.styled';

export default function HowItWorks() {
  return (
    <Container>
      <Text variant="title-big-grey-42" color={Colors.BLACK}>
        How it works
      </Text>
      <FeatureGrid items={featureItems} />
    </Container>
  );
}

const featureItems = [
  {
    iconBackgroundColor: Colors.PURPLE_VARIANTS[10],
    icon: <UserPlus color={Colors.PURPLE_VARIANTS[70]} width={65} />,
    title: 'Sign up free',
    description: 'Takes 2 minutes. No credit card.',
  },
  {
    iconBackgroundColor: Colors.MAIN_VARIANTS[10],
    icon: <BookAlt color={Colors.MAIN_VARIANTS[60]} width={65} />,
    title: 'Browse 500+ activities',
    description: (
      <>
        Filter by theme, level or skill. <br /> Everything ready to use.
      </>
    ),
  },
  {
    iconBackgroundColor: Colors.SUCCESS_VARIANTS[10],
    icon: (
      <Image
        src={`${staticCdnHost}/img/pricing/rocket.svg`}
        alt="Watch your students thrive"
        width={57}
        height={57}
      />
    ),
    title: 'Open, play, teach.',
    description: (
      <>
        Connect the projector. <br /> Hit play. <br />
        Your students do the rest.
      </>
    ),
  },
];
